/*******************************************************
HANDLE KEYBOARD NAVIGATION
Handle navigating search results via keyboard and triggering actual search.
********************************************************/

import clearSearch from './clear';

export default function handleKeyboardNavigation(e) {

    // Exit out if any key other than enter, esc, up or down is pressed
    if (![13, 27, 38, 40].includes(e.which)) { return; }

    // Get the search data
    const $input = $(e.currentTarget);
    const searchTerm = $input.val() || '';
    const sport = $input.data('sport') || '';

    // Check for various keyboard actions
    const keyPressed = {
        enter: (e.which === 13),
        esc  : (e.which === 27),
        down : (e.which === 40),
        up   : (e.which === 38),
    };

    // If the input is empty or the ESC key is pressed,
    // then reset everything to its initial state and exit out
    if (!searchTerm || keyPressed.esc) { clearSearch(); return; }

    const activeClass = 'is-active';
    const $results = $('.search-result');
    const $current = $(`.search-result.${activeClass}`);
    const aResultExists = ($results.length > 0);
    const aResultIsSelected = ($current.length > 0);
    let $next;

    // If the enter key is pressed while a search result is selected, go to the selected player
    // If the entry key is pressed while a search result is not selected, go the search page
    if (keyPressed.enter) {
        if(aResultIsSelected){
            window.location.href = $current.find('a').attr('href');
            return;
        } else{

            // The link to the search page should awlays include the current search term
            let searchPage = '/search.php?term=' + String(searchTerm).toLowerCase().replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"');

            // Add the sport if one exists
            searchPage += ('&sport=' + sport);

            window.location.href = searchPage;
            return;
        }
    }

    // If the key pressed is up/down and a result exists
    if( (keyPressed.down || keyPressed.up) && aResultExists){

        // If the down key is pressed, go to the next result in the list. If we're already at the end, move to the start.
        if (keyPressed.down) {
            $next = (aResultIsSelected && $current.next().length) ? $current.next() : $results.first();
        }

        // If the up key is pressed, go to the previous result in the list. If we're already at the beginning, move to the end.
        if (keyPressed.up) {
            $next = (aResultIsSelected && $current.prev().length) ? $current.prev() : $results.last();
        }

        // Remove the active class from the current element and add to the next one
        if ($current) { $current.removeClass(activeClass); }
        $next.addClass(activeClass);

        // Scroll to the active search result
        const $resultsContainer = $('#player-search-results');
        $resultsContainer.animate({
            scrollTop: $next.position().top + $resultsContainer.scrollTop(),
        }, 50);

    }

}
